import { cn } from "@/utils/className";
import React from "react";

interface FeedbackCardProps {
  children: React.ReactNode;
  className?: string;
  minWidth?: string;
}

export const FeedbackCard: React.FC<FeedbackCardProps> = ({ children, className = "", minWidth = "25vw" }) => (
  <div className={`relative rounded-[20px] shadow-[0_4px_20px_rgba(0,0,0,0.08)] backdrop-blur-md" ${className}`}>
    <div className="absolute inset-0 bg-[rgba(0,0,0,0.1)] rounded-[20px]" />
    <div
      className={cn(
        "rounded-[20px]",
        "backdrop-blur-[20px]",
        " bg-[rgba(24, 26, 32, .6)]", "pt-14 pb-6")}
      style={{
        minWidth: minWidth,
        // background: "rgba(24, 26, 32, .6)"
      }
      }
    >
      {children}
    </div>
  </div >
);
